import axios from "axios";
import { baseUrl } from "../config/urlRoutes";

let headers = new Headers();
headers.append("Access-Control-Allow-Origin", "http://localhost:5000/api/");
headers.append("Access-Control-Allow-Credentials", "true");
// let token = localStorage.getItem("jwtToken");
// console.log(token,"token")
// if (token) {
//   headers.append("x-access-token", token);
// }

export const getRequest = async (url, params) => {
  try {
    let response = await axios.get(baseUrl + url, params, {
      Headers: headers,
    });
    if (response) {
      return response;
    }
  } catch (e) {
    return e;
  }
};

export const postRequest = async (url, params) => {
  try {
    let response = await axios.post(baseUrl + url, params, {
      headers: headers,
    });
    // console.log("Axios Response", response);
    if (response) {
      return {
        data: response,
      };
    }
  } catch (e) {
    //console.info("An error occured", e);
    return e;
  }
};

export const signupPostRequest = async (
  url,
  params,
  successCallback,
  errorCallback
) => {
  try {
    let response = await axios
      .post(baseUrl + url, params, {
        headers: headers,
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
    if (response) {
      return {
        data: response,
      };
    }
  } catch (e) {
    return e;
  }
};
